export const DEPARTURE_REPORT_DATA_COLUMNS = [
  {
    Header: "DATE",
    accessor: "Date",
    width : 1
  },
  {
    Header: "MODULE",
    accessor: "DataOf",
    width : 1
  },
  {
    Header: "ON HOLD CONTAINER",
    accessor: "isOnHold",
    width : 1
  },
  {
    Header: "FACTORY IN DATE & TIME",
    accessor: "Gate_In_Date",
    width : 1
  },
  {
    Header: "FACTORY OUT DATE & TIME",
    accessor: "Gate_Out_Date",
    width : 1
  },
  {
    Header: "CONTAINER NO",
    accessor: "Container_Number",
    width : 1
  },
  {
    Header: "SEAL NO",
    accessor: "Seal_No",
  },
  {
    Header: "LR NO",
    accessor: "LR_NO",
    width : 1
  },
  {
    Header: "VEHICLE NO",
    accessor: "Vehicle_No",
    width : 1
  },
  {
    Header: "CARRIER",
    accessor: "Carrier",
    width : 1
  },
  {
    Header: "CLEARANCE",
    accessor: "Clearence",
    width : 1
  },
  {
    Header: "DEST COUNTRY",
    accessor: "Dest_Country",
    width : 1
  },
  {
    Header: "DEST PORT",
    accessor: "Dest_Port",
    width : 1
  },
  {
    Header: "FINAL DEST",
    accessor: "final_destination",
    width : 1
  },
  {
    Header: "PRODUCT",
    accessor: "Product",
    width : 1
  },
  {
    Header: "BOOKING NO.",
    accessor: "Booking_Number",
    width : 1
  },
  {
    Header: "TRANSPORTER",
    accessor: "Transporter",
    width : 1
  },
  {
    Header: "PICK UP LOCATION",
    accessor: "pick_up_location",
    width : 1
  },
  {
    Header: "SAP CODE",
    accessor: "SAP_code",
    width : 1
  },
  {
    Header: "CONTAINER TYPE",
    accessor: "Container_Type",
    width : 1
  },
  {
    Header: "DRIVER NO",
    accessor: "Driver_No",
    width : 1
  },
  {
    Header: "REMARK",
    accessor: "Remarks",
    width : 1
  },
  {
    Header: "UPLOAD DOC",
    accessor: "upload_doc",
    width : 1
  },
  {
    Header: "VIEW DOC.",
    accessor: "view_doc",
    width : 1
  },
];